/* eslint-disable jsx-a11y/label-has-associated-control */
import { Button } from "@benefit-systems/common-components";
import { Field, Form, Formik } from "formik";
import { func, object, string } from "prop-types";
import { useCallback, useState } from "react";
import { useDispatch } from "react-redux";

import { FORM_TYPES } from "web/Pages/Checkout/Subscription/BenefitSummary/BenefitForm/constants";
import { updateDataInDraft } from "web/Pages/Checkout/Subscription/BenefitSummary/BenefitForm/utils";

import Loading from "web/Layout/Common/Loading";
import __ from "web/Layout/Translations";

import ValidationErrorMessage from "web/Components/Common/ValidationErrorMessage";

import { validateField } from "web/utils/system/formValidator/validation";

import {
  setNotificationError,
  setNotificationSuccess,
} from "web/features/app/appSlice";

import styles from "./editEmail.scss";

const emailFieldName = "receiverEmail";

const EditEmail = ({
  activeForm,
  benefitUUID,
  setChangedEmail,
  closeModal,
}) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const initialValues = { [emailFieldName]: activeForm?.receiverEmail };
  const onSuccessFunction = (response) => {
    setLoading(false);
    dispatch(
      setNotificationSuccess({
        message: __("Adres e-mail został poprawnie zmieniony."),
      })
    );
    setChangedEmail(response);
    closeModal();
  };
  const onErrorFunction = () => {
    setLoading(false);
    dispatch(
      setNotificationError({ message: __("Nie udało się wysłać formularza.") })
    );
  };
  const submitHandler = useCallback((values) => {
    setLoading(true);

    const data = {
      id: activeForm?.id,
      receiver: activeForm?.receiver,
      ...values,
    };

    updateDataInDraft(
      benefitUUID,
      data,
      FORM_TYPES.ACTIVE_FORMS,
      onSuccessFunction,
      onErrorFunction,
      true
    );
  }, []);

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <Formik initialValues={initialValues} onSubmit={submitHandler}>
          <Form>
            <label htmlFor={emailFieldName} className="visually-hidden">
              E-mail
            </label>
            <Field
              type="email"
              name={emailFieldName}
              component="input"
              placeholder={activeForm?.receiverEmail}
              validate={validateField(["required", "email"])}
              className={styles.input}
            />
            <ValidationErrorMessage name={emailFieldName} />
            <Button
              type="submit"
              ariaLabel={__("Wyślij")}
              variant="tertiary"
              className={styles.submitBtn}
            >
              {__("Wyślij")}
            </Button>
          </Form>
        </Formik>
      )}
    </>
  );
};

EditEmail.propTypes = {
  activeForm: object.isRequired,
  benefitUUID: string.isRequired,
  setChangedEmail: func.isRequired,
  closeModal: func.isRequired,
};

export default EditEmail;
